import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const activateContractrental = (id,items,amort)=> {
	return axios.post(API + "contracts/contractrental-activate/"+id+"/" ,{items,amort},{ headers: authHeader() })}

const ActivateContractRentalService = {
    activateContractrental,
  };
  export default ActivateContractRentalService;